import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { WhySection } from '../components/WhySection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { WhoSection } from '../components/WhoSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#faf9f7] text-slate-900 font-sans selection:bg-teal-100 selection:text-teal-900" data-id="element-198">
      <Hero data-id="element-199" />
      <ProblemSection data-id="element-200" />
      <WhySection data-id="element-201" />
      <SolutionSection data-id="element-202" />
      <BenefitsSection data-id="element-203" />
      <FeaturesSection data-id="element-204" />
      <WhoSection data-id="element-205" />
      <PricingSection data-id="element-206" />
      <Footer data-id="element-207" />
    </main>;
}